export const Roles = {
  SUPER_ADMIN: "super-admin",
  ADMIN: "admin",
  COMPANY_ADMIN: "company-admin",
  APPROVER: "approver",
  VIEWER: "viewer",
  USER: "user",
  SUPPORT: "support",
} as const;

export type RoleName = (typeof Roles)[keyof typeof Roles];

/**
 * The internal back-office roles admitted by the admin surfaces
 * (admin-web's `authGuard` and admin-api's `AdminRoleGuard` / auth gates).
 *
 * Deliberately excludes `Roles.COMPANY_ADMIN` — that is the customer-tier
 * role `apps/api` mints; admin-api/admin-web are strictly internal.
 * Typed as `readonly RoleName[]` (not an `as const` tuple) so call sites
 * can check plain strings via `INTERNAL_ADMIN_ROLES.includes(r as RoleName)`.
 */
export const INTERNAL_ADMIN_ROLES: readonly RoleName[] = [
  Roles.ADMIN,
  Roles.SUPER_ADMIN,
];
